import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminUserApi } from '../lib/api'
import type { UpdateUserRequest } from '../types/admin'

export function useAdminUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: async () => {
      const response = await adminUserApi.getAll()
      return response.data
    },
  })
}

export function useUpdateUser() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateUserRequest }) =>
      adminUserApi.update(id, data).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}

export function useCommitteeOptions() {
  return useQuery({
    queryKey: ['admin', 'committees', 'options'],
    queryFn: async () => {
      const response = await adminUserApi.getCommitteeOptions()
      return response.data
    },
  })
}

export function useUploadPortrait() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, file }: { id: string; file: File }) =>
      adminUserApi.uploadPortrait(id, file).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}

export function useDeletePortrait() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => adminUserApi.deletePortrait(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}
